import { OrganizationEditorParams } from '../../typings/organizations';

export const UPDATE_BANNERS_ORGANIZATION_IDS =
    'UPDATE_BANNERS_ORGANIZATION_IDS';
export type UPDATE_BANNERS_ORGANIZATION_IDS = typeof UPDATE_BANNERS_ORGANIZATION_IDS;
export interface UpdateBannerOrganizationIds {
    type: UPDATE_BANNERS_ORGANIZATION_IDS;
    params: OrganizationEditorParams[];
}
export function updateBannersOrganizationIds(
    params: OrganizationEditorParams[]
): UpdateBannerOrganizationIds {
    return {
        type: UPDATE_BANNERS_ORGANIZATION_IDS,
        params
    };
}

export type BannerOrganizationAction = UpdateBannerOrganizationIds;
